import React from 'react';
import { css } from '@emotion/core';
import throttle from 'lodash.throttle';

import {
    containers,
    fontSize,
    Grid,
    MixBlendBackground,
    MixBlendDifference,
    MixBlendText,
    zIndexes,
} from 'style';

const JumpTo = (e, section) => {
    e.preventDefault();
    e.stopPropagation();
    const bounds = document
        .querySelector(`#${section.id}`)
        .getBoundingClientRect();
    window.scrollTo({ top: bounds.top + window.scrollY + 5, behavior: 'smooth' });

    return false;
};

class JumpToComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            offset: 0,
            top: 0,
            width: 0,
            fixed: false,
            active: true,
            parent: {},
            activeSectionIndex: 0,
            submenuOpen: false,
            caseSections: props.caseSections
        };

        this.outer = React.createRef();
        this.inner = React.createRef();

        this.handleResize = this.handleResize.bind(this);
        this.handleResizeThrottled = throttle(this.handleResize, 250);

        this.setParentRect = this.setParentRect.bind(this);
        this.setParentRectTrottled = throttle(this.setParentRect, 1000);

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        this.init();
        this.addEventListeners();
    }
    componentWillUnmount() {
        this.removeEventListeners();
    }
    addEventListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResizeThrottled);
    }
    removeEventListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResizeThrottled);
    }
    handleResize() {
        this.setParentRect();
    }
    init() {
        this.setParentRect();
    }
    getOffset() {
        return 12.8;
        const headerdiv = document.querySelector('#mainNavigation div');

        if (!headerdiv) return 0;

        let headerbounds = headerdiv.getBoundingClientRect();
        return headerbounds.top;
    }
    setTops() {
        const caseSections = this.state.caseSections;
        caseSections.forEach(element => {
        element.top = document.querySelector(`#${element.id}`).getBoundingClientRect().top + window.pageYOffset;
        element.active = false;
        });
        this.setState({ caseSections: caseSections });
        this.handleScroll();
    }
    setParentRect() {
        if (!this.outer.current){
            return;
        }
        this.setTops();
        const outerbounds = this.outer.current.getBoundingClientRect();
        const innerbounds = this.inner.current.getBoundingClientRect();

        const offset = this.getOffset();

        const newState = {
            offset: offset,
            width: outerbounds.width,
            height: innerbounds.height,
            parent: {
                top: outerbounds.top + window.scrollY,
                height: 10000,
            },
        };
        newState.active = true; //newState.parent.height > window.innerHeight * 0.7;

        this.setState(newState, this.respositionElements);
    }

    

    handleScroll() {
        this.setParentRectTrottled();
        if (this.state.active === true) {
            this.respositionElements();
        }

        if (this.state.caseSections.length) {
            const caseSections = this.state.caseSections;
            let activeElement = 'none';
            caseSections.forEach((element, i) => {
              element.active = false;
              if (window.pageYOffset > element.top) {
                activeElement = i;
              }
            });
            if (activeElement != 'none') {
              caseSections[activeElement].active = true;
            }
            this.setState({ caseSections: caseSections, activeSectionIndex: activeElement });
        }
    }
    respositionElements() {
        const scrollTop = window.scrollY + this.state.offset;
        const isAfterTop = scrollTop > this.state.parent.top;
        const isBeforeBottom =
            scrollTop <
            this.state.parent.top +
                this.state.parent.height -
                this.state.height;
        if (isAfterTop && isBeforeBottom) {
            this.setState({ fixed: true, top: this.state.offset });
        } else {
            if (isAfterTop) {
                this.setState({
                    fixed: false,
                    top: this.state.parent.height - this.state.height,
                });
            }
            if (!isAfterTop) {
                this.setState({ fixed: false, top: 0 });
            }
        }
    }
    toggleSubmenu(e){
        e.stopPropagation();
        e.preventDefault();
        this.setState({ submenuOpen: !this.state.submenuOpen });
        return false;
    }
    closeSubmenu(e){
        e.stopPropagation();
        e.preventDefault();
        this.setState({ submenuOpen: false });
        return false;
    }
    render() {
        
        const { caseSections, activeSectionIndex, submenuOpen, fixed, top, width } = this.state;
        return (
            <div css={sharedcss}>
                <div ref={this.outer} css={jumptoWrapper}>

                    <div css={jumptoDesktop} className={`jumpto-items-${caseSections.length}`} >
                    
                        <div
                            ref={this.inner}
                            className={`fixed-wrapper ${fixed ? 'is-fixed' : 'is-relative'}`}
                            style={{
                                // top: `${top}px`,
                                width: fixed ? `${width}px` : 'auto',
                            }}>

                            <div className="wrapper">
                                <div className="container-fluid">
                            
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-8 col-sm-offset-4">
                                            <div className="jumpto">
                                                
                                                <span className="o5 title">Jump to:</span>
                                                <ul data-cursor="focus"
                                                                    data-cursor-persistance="200">
                                                    {caseSections &&
                                                        caseSections.map(section => (
                                                            <li key={`${section.id}`}>
                                                                <a
                                                                        href={`#${section.id}`}
                                                                        className={`dot-link ${section.active ? 'active' : ''}`}
                                                                        onClick={e => {
                                                                            JumpTo(e, section);
                                                                            this.closeSubmenu(e);
                                                                        }}>
                                                                        {section.sectionTitle}
                                                                    </a>
                                                            </li>
                                                        ))}
                                                </ul>
                                    
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="spacer" size="10"></div>
                </div>

                <div css={jumptoMobile} className={`${submenuOpen ? 'is-open' : ''}`} 
                    onClick={e => {
                        this.closeSubmenu(e);
                    }}>
                    <div className={`submenu-wrapper`}>
                    <div className="wrapper">
                        <div className="container-fluid">
                    
                        <div className="row submenu">
                            <div className="col-xs-6">
                                <div className="o5 title">Jump to:</div>
                            </div>
                            <div className="col-xs-6">
                                <div 
                                className={``}>
                                    <ul>
                                        {caseSections &&
                                            caseSections.map(section => (
                                                <li key={`${section.id}`}>
                                                    <a
                                                        href={`#${section.id}`}
                                                        className={`dot-link ${section.active ? 'active' : ''}`}
                                                        data-cursor="focus"
                                                        data-cursor-persistance="200"
                                                        onClick={e => {
                                                            JumpTo(e, section);
                                                            this.closeSubmenu(e);
                                                        }}>
                                                        {section.sectionTitle}
                                                    </a>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        </div></div>
                    </div>


                    <div className="wrapper">
                    <div className="row">
                    <div className="col-xs-6 col-xs-offset-6">
                        <div 
                            className={`active-section active-item-${activeSectionIndex}`}
                            data-cursor="focus"
                            data-cursor-persistance="200"
                            onClick={e => {
                                this.toggleSubmenu(e);
                            }}
                            >


                            <svg
                                width={10}
                                height={6}
                                viewBox="0 0 10 6"
                                xmlns="http://www.w3.org/2000/svg"
                                className='chevron'
                                >
                                <path
                                    d="M5.243 1l4.242 4.243-4.242 4.242L1 5.243 5.243 1z"
                                    stroke="#000"
                                    fill="none"
                                    fillRule="evenodd"
                                    strokeDasharray="6,12"
                                    strokeLinecap="square"
                                />
                                </svg>
                            <ul
                                >
                                {caseSections &&
                                    caseSections.map(section => (
                                        <li key={`${section.id}`}>
                                            <span
                                                className={`dot-link`}
                                                >
                                                {section.sectionTitle}
                                            </span>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
                </div>



                </div>
            </div>
        );
    }
}

export default JumpToComponent;




const breakpoint = 1024;
const stackbreakpoint = 768;


const heights = () => {
    let styles = {};
    for (let $i = 0; $i < 10; $i++) {
      styles["&.jumpto-items-" + $i + ""] = {
        height: ($i*(.7+.7+.815)) + "rem",
        // transitionDelay: "1s," + $i * 0.08 + "s",
      };
    }
    return styles;
};

const mobileNavTransforms = () => {
    let styles = {};
    for (let $i = 0; $i < 10; $i++) {
      styles["&.active-item-" + $i + " ul"] = {
        
        transform: `translateY(-${($i*(2.4))}rem)`,
        // transitionDelay: "1s," + $i * 0.08 + "s",
      };
    }
    return styles;
};

const textpadding = '.7rem';

/* Wrapper */
const jumptoDesktop = css` 


    position: relative;
    ${MixBlendDifference};


    @media (max-width: ${breakpoint-1}px){
        
        ${heights()}
        
    }

    .jumpto {
        color: white;
        position: relative;
        z-index: 2;

        transition: transform 500ms;

        .title {
            padding: 0.5em 0;
            margin-right: 1.8em;
        }
        
        
        
        @media (max-width: ${breakpoint-1}px){
            display: flex;
            span {
                display: inline-block;
                width: 50%;
            }
            li{
                display: block;
            }
            .dot-link{
                // padding: ${textpadding} 0.5rem;
                
                margin-left: -1.5rem;
            }
        }

        .dot-link {
            @media (hover: none) {
                opacity: 1;
            }
        }
    }


    .dot-link {
        margin-right: 1rem;
        
        line-height: 2.4rem;

        

        &:before{
            background-color: #fff;
        }
    }

    li {
        display: inline;
    }

`;


const jumptoMobile = css`
    position: fixed;
    top: 0;
    z-index: 9;
    width: 100%;
    min-height: 0;
    left: 0;
    // overflow: hidden;
    color: black;
    transition: min-height 600ms 300ms;

    &:after{
        content: "";
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(4rem - 1px);
    }

    @media (min-width: ${breakpoint}px){
        display: none;
    }

    .submenu-wrapper{
        position: relative;
        top: 0;
        left: 100vw;
        width: 100%;

        &:before{
            content: "";
            position: absolute;
            z-index: 1;
            top: 0;
            bottom: -100vh;
            left: -100vw;
            right: -100vw;
            background-color: rgba(0,0,0,.2);
            transition: opacity 200ms;
            opacity: 0;
            pointer-events: none;
        }

        &:after{
            content: "";
            position: absolute;
            z-index: 2;
            top: 0;
            bottom: 0;
            left: -100vw;
            right: -100vw;
            background-color: #fff;
        }

        height: auto;
        transition: transform 500ms;
        transform: translateY(-140%);
        

        .submenu{
            height: auto;
            position: relative;
            z-index: 4;
            margin-top: 4rem;
            overflow: auto;
            color: #000;
            padding: 1rem 0;
        }
    }

    &.is-open{
        min-height: 100vh;
        transition: min-height 0ms 0ms;

        &:after{
            background-color: white;
        }
        .submenu-wrapper{
            left: 0;
            transform: translateY(0);

            &:before{
                opacity: 1;
            }
        }

        .active-section .chevron{
            transform: rotate(0deg);
        }
    }

    .active-section{
        position: fixed;
        z-index: 5;
        height: 2.4rem;
        overflow: hidden;
        top: 0.8rem;
        padding-right: 1.5rem;
        
        &.active-item-none ul{
            transform: translateY(3em);
        }
        ${mobileNavTransforms()}

        .chevron{
            position: absolute;
            right: 0;
            top: 1rem;
            transform: rotate(180deg);
        }

        ul{
            transition: transform 500ms;
        }
        .dot-link{
            opacity: 1;
        }
        

    }

    .mobile-nav{

        @media (min-width: ${breakpoint}px){
            display: none;
        }
        

    }

    .dot-link{
        // padding: ${textpadding} 0.5rem;
        line-height: 2.4rem;
        margin-left: -.35rem;
        display: block;
        text-decoration: none;
        color: black;
        
        &:before{
            background-color: #000 !important;
        }
        &.active{

        }
    }
    li{
        display: block;
    }

    .title{
        // padding: ${textpadding} 0;
        line-height: 2.4rem;
    }
`;

const sharedcss = css`

    font-size: .815rem;
    line-height: 1;
    ul{
        font-size: .815rem;
        line-height: 1;
    }
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: inline-block;
    }

    
`;

const jumptoWrapper = css`
    

    ${MixBlendDifference}

    position: absolute;
    bottom: 5.83333vmax;
    z-index: 10;
    width: 100%;

    
    
    


    .fixed-wrapper{
        z-index: ${zIndexes.zNav + 1};
        position: relative;
        &.is-fixed{
            position: fixed;
            top: .8rem;
            @media (max-width: ${breakpoint-1}px){
                position: relative;
                top: 0 !important;

                .jumpto {
                    // transform: translateY(-120%);
                    color: white;
                }
            }
        }
    }


    
    
    
    @media (min-width: ${breakpoint}px){
        height: auto;
    }
`;
